import React, { Component } from "react";
import { Row, Col, CardBody, Card, Container, CardTitle, Button } from "reactstrap";

// action
import {
  registerUser,
  apiError,
  registerUserFailed,
  registerShop,
} from "../../store/actions";

import profileImg from "../../assets/images/profile-img.png";
import logoLight from "../../assets/images/tracklastmile-logo.svg";
import "../Marketing/marketing.css";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

class ShopRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.apiError("");
    this.props.registerUserFailed("");
  }

  render() {
    return (
      <div className="tlm-home tlm-dark min-vh-100">
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2"></i>
          </Link>
        </div>

        <div className="d-flex justify-content-center pt-4 pb-2">
          <Link to="/">
            <img
              src={logoLight}
              alt="TrackLastMile"
              className="img-fluid d-block tlm-home-logo"
            />
          </Link>
        </div>

        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={12} lg={10} xl={9}>
                <Card className="overflow-hidden tlm-card border-0">
                  <div className="tlm-soft-primary-dark">
                    <Row>
                      <Col className="col-8">
                        <div className="text-dark p-4">
                          <p className="text-uppercase tlm-eyebrow font-weight-bold small mb-2">
                            The All-in-One Delivery Platform
                          </p>
                          <h4 className="text-dark mb-1">Start Your TrackLastMile Trial</h4>
                          <p className="mb-0">
                            Launch your branded delivery service in weeks, not years.
                          </p>
                        </div>
                      </Col>
                      <Col className="col-4 align-self-end text-right">
                        <img src={profileImg} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="p-4 p-lg-5">
                    <CardTitle className="mb-2 h4 text-dark">Trial Registration</CardTitle>
                    <p className="tlm-text-muted mb-4 tlm-trial-lead">
                      We are improving onboarding to make setup faster for new partners.
                      Reach out using one of the options below and our team will assist you directly.
                    </p>

                    <Row className="mb-2">
                      <Col md="4" className="mb-3">
                        <div className="tlm-trial-step h-100">
                          <h6 className="mb-2 font-weight-bold text-dark">1. Contact us</h6>
                          <p className="mb-0 tlm-text-muted">Call or email us with your business name and city.</p>
                        </div>
                      </Col>
                      <Col md="4" className="mb-3">
                        <div className="tlm-trial-step h-100">
                          <h6 className="mb-2 font-weight-bold text-dark">2. Quick follow-up</h6>
                          <p className="mb-0 tlm-text-muted">We will schedule a short onboarding call within one business day.</p>
                        </div>
                      </Col>
                      <Col md="4" className="mb-3">
                        <div className="tlm-trial-step h-100">
                          <h6 className="mb-2 font-weight-bold text-dark">3. Launch trial</h6>
                          <p className="mb-0 tlm-text-muted">Your branded trial environment is prepared and shared with your team.</p>
                        </div>
                      </Col>
                    </Row>

                    <div className="d-flex flex-wrap align-items-center tlm-trial-actions">
                      <Button color="primary" tag="a" href="tel:+15194762069" className="mr-2 mb-2 tlm-btn-primary">
                        Call +1 519-476-2069
                      </Button>
                      <Button color="outline-light" tag="a" href="mailto:admin@tracklastmile.com" className="mb-2 tlm-btn-outline">
                        Email admin@tracklastmile.com
                      </Button>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    Already have an account ?{" "}
                    <Link
                      to="/login"
                      className="font-weight-medium text-primary"
                    >
                      {" "}
                      Login
                    </Link>{" "}
                  </p>
                  <p>
                    © {new Date().getFullYear()} TrackLastMile. Crafted with{" "}
                    <i className="mdi mdi-heart text-danger"></i> by TurboDevelop
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  const { user, registrationError, loading } = state.Account;
  return { user, registrationError, loading };
};

export default withRouter(
  connect(mapStatetoProps, {
    registerUser,
    apiError,
    registerUserFailed,
    registerShop,
  })(ShopRegister)
);
